import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Button from '@starbucks-web/pattern-library/lib/components/button';

import { queryParamsSelector } from 'shared/app/state/selectors/routes';
import getReturnUrl from 'shared/universal/get-return-url';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

export const JoinRewardsCta = () => {
  const queryParams = useSelector(queryParamsSelector);

  const returnUrl = getReturnUrl(queryParams);
  const search = returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : '';

  return (
    <Button
      className="color-greenStarbucks text-bold text-xs flex justify-center"
      data-e2e="joinStarbucksRewards"
      href={`/account/create${search}`}
      visualStyle="textLink"
    >
      <FormattedMessage {...sharedCallsToAction.joinStarbucksRewards} />
    </Button>
  );
};

export default JoinRewardsCta;
